/**
 * Object.keys() transforms null and undefined keys to their string value ('null', 'undefined')
 * @param key
 */
const isKeyEmpty = (key: string) => key === 'null' || key === 'undefined' || !key;

export default isKeyEmpty;
